import classNames from 'classnames';

import Typography, { TypographyProps } from './Typography';

import styles from '../../styles/typography/duration.module.css';

function Itemcount({ tag = 'div', className = null, ...props }: TypographyProps) {
    return (
        <Typography
            tag={tag}
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
            {...props}
        />
    );
}

export default Itemcount;
